import React from 'react';
import axiosAdapter from '../utils/Adapters';
import config from '../config';
import { CMSAPI_INDEX } from '../utils/CmsAPI';

export const getYouTubeImgUrl = (url) => {
  if (!url) return '';

  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  const result = match && match[2].length === 11 ? match[2] : '';

  return `https://img.youtube.com/vi/${result}/0.jpg`;
};

export const highlightKeywords = (text, keyword) => {
  if ((!text && !text.trim()) || (!keyword && !keyword.trim())) {
    return text;
  }

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const regex = new RegExp(`(${escapedKeyword})`, 'gi');

  return text
    .split(regex)
    .map((part, index) =>
      index % 2 === 1 && part.toLowerCase() === keyword.toLowerCase() ? (
        <b key={index}>{part}</b>
      ) : (
        part
      ),
    );
};

export const debounce = (fn, delay) => {
  let timer;
  const debounced = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
};

export const customApi = async (
  pathName,
  pageType,
  qArray,
  start,
  max,
  sortBy,
  enableDate,
  custom_q,
) => {
  try {
    const q = [];
    if (pathName) {
      q.push(`Path:/${pathName}.xml`);
    }
    if (pageType) {
      q.push(`TeamSite/Templating/DCR/Type:${pageType}`);
    }
    if (qArray && Array.isArray(qArray)) {
      q.push(...qArray.filter((item) => item));
    }
    if (enableDate) {
      const dateTime = new Date().getTime();
      q.push(`onlineTime:<=${dateTime}`);
      q.push(`offlineTime:>=${dateTime}`);
    }
    const queryParameters = {
      sortBy,
      prefixPath: config.lscsPath,
      q: custom_q ? custom_q : q.map((v) => `(${v})`).join(' AND '),
      start,
      max,
      projectName: config.cmsProjectName,
      enableDate: false,
    };
    const url = CMSAPI_INDEX(queryParameters);

    const response = await axiosAdapter({ url });
    return {
      total: response.data.total,
      data: response.data.result.assets.map((v) => {
        const { content, metadata, ...rest } = v;
        return {
          ...rest,
          topMetadata: metadata,
          ...v.content.content,
        };
      }),
    };
  } catch (error) {
    console.error('customApi error:', error);
    return { total: 0, data: [] };
  }
};

export const getApiDatas = async (url) => {
  try {
    const response = await axiosAdapter({ url });

    return response.data.result.assets.map((v) => {
      const { content, metadata, ...rest } = v;
      return {
        ...rest,
        topMetadata: metadata,
        ...v.content.content,
      };
    });
  } catch (error) {
    return [];
  }
};

export const getUrlSeoTitle = (title) => {
  if (title) {
    return title
      .replace(/[^a-zA-Z0-9\s]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase()
      .replace(/^-+|-+$/g, '');
  }
  return '';
};

export const getFeaturesTitle = (item, lang) =>
  ({
    flash1: item[lang]?.flash1_details?.flash1_title,
    flash2: item[lang]?.flash2_details?.flash2_title,
    flash3: item[lang]?.flash3_details?.flash3_title,
    flash4: item[lang]?.flash4_details?.flash4_title,
    photo: item[lang]?.photo_details?.photo_title,
    story: item[lang]?.story_details?.story_title,
    // fullWidth: item[lang]?.fullWidth_details?.fullWidth_headline,
  }[item.basicInfo?.templateType]);

export const isHtmlTitle = (str) => /<[^>]+>/i.test(str);

export const replaceParentStyle = (str, className) => {
  return (
    str?.replace(/<style>([\s\S]*?)<\/style>/g, (match, content) => {
      return content.startsWith('<!--') && content.endsWith('-->')
        ? `<style><!-- .${className} {\n ${content.slice(4, -3).trim()} \n} --></style>`
        : `<style>.${className} {\n ${content} \n}</style>`;
    }) || ''
  );
};
